import React from 'react'
import VideoPlayer from './Media/VideoPlayer';
import { usePost } from '../context/PostContext';
import { useState, useEffect } from 'react';

export default function PostMediaPreview() {

    const { uploadMedia } = usePost();
    const [ mediaList, setMediaList ] = useState([]);

    useEffect(() => {
        if(uploadMedia) setMediaList(Array.from(uploadMedia))
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uploadMedia]);

    function getUrl(file) {
        return URL.createObjectURL(file)
    };
    const displayByType = (media) => {
        const fileType = media?.type.split('/')[0];
        if (fileType === 'image') {
            return <div className='w-full'><img src={getUrl(media)} alt="" className="w-full object-cover rounded-lg" /></div>
        } else {
            return <VideoPlayer controls={false} src={getUrl(media)} />
        }
    }
    return (
        <div className={`mb-4 mx-3 overflow-hidden`}>
            {mediaList?.length === 1 && <div className="w-full">
                {displayByType(mediaList[0])}
            </div>}

            {mediaList?.length > 1 && <div className="flex gap-2 items-start">
                <div key={getUrl(mediaList[0])} className="w-[67%]">
                    {displayByType(mediaList[0])}
                </div>
                
                <div className="flex flex-col h-full justify-between gap-3 w-[33%]">
                    {mediaList?.length >= 2 && <div className=''>
                        {displayByType(mediaList[1])}    
                    </div>}
                    {mediaList?.length >= 3 && <div className="w-full relative">
                        {displayByType(mediaList[2])}
                        {mediaList.length > 3 && <div className="absolute top-0 h-full gap-2 w-full flex justify-center bg-black bg-opacity-30 rounded-lg">
                            <div className="flex justify-center items-center">
                                <span className="text-4xl text-white">+{mediaList.length - 3}</span>
                            </div>
                        </div>}
                    </div>}
                </div>
            </div>}
        </div>
    )
}
